import * as React from 'react';
import PropTypes from 'prop-types';
var SvgSportsSurfingNormalMedium = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M30.41.53c-.37 0-9.09.18-18 9.05S.63 26 .51 26.27a1 1 0 00.93 1.37H4.3v2.86a1 1 0 001 1 .94.94 0 00.37-.07c.32-.13 8-3.18 16.68-11.92 8.52-8.52 9-16.9 9-17.88a.31.31 0 000-.1 1 1 0 00-.94-1zm-29 26.11s3-7.66 11.7-16.35c7.16-7.16 14.23-8.46 16.5-8.7L23.9 7.34 4.59 26.64zm20.24-7.84C13 27.49 5.3 30.5 5.3 30.5v-3.16L24.49 8.16 24.6 8l.74-.73 5-5c-.23 2.3-1.53 9.37-8.69 16.53z"
  }));
});
SvgSportsSurfingNormalMedium.defaultProps = {
  height: 32,
  width: 32
};
SvgSportsSurfingNormalMedium.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgSportsSurfingNormalMedium;